// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3x5jo","title":"BackImages_title__1PA-I","images":"BackImages_images__YS-yH"};